import { comments } from '../../../mocks/comments';

export function CommentsList() {
  return (
    <div className="space-y-1.5 sm:space-y-2 md:space-y-3 max-h-64 sm:max-h-80 md:max-h-96 overflow-y-auto pr-1 md:pr-2 custom-scrollbar">
      {comments.map((comment, index) => (
        <div
          key={index}
          className="bg-white/10 backdrop-blur-sm rounded-md sm:rounded-lg p-1.5 sm:p-2 md:p-3 border border-white/5 hover:bg-white/15 transition-all duration-300"
        >
          <div className="flex items-start gap-1.5 sm:gap-2 md:gap-3">
            <div className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 flex-shrink-0">
              <img
                alt={comment.name}
                className="w-full h-full rounded-full object-cover border border-emerald-400/50 sm:border-2"
                src={comment.avatar}
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1 sm:gap-1.5 md:gap-2 mb-0.5 md:mb-1">
                <span className="text-white font-semibold text-[10px] sm:text-xs md:text-sm truncate">
                  {comment.name}
                </span>
                <span className="text-white/50 text-[9px] sm:text-xs flex-shrink-0">
                  {comment.time}
                </span>
              </div>
              <p className="text-white/90 text-[10px] sm:text-xs md:text-sm leading-relaxed">
                {comment.text}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
